import type { TGetPropostaRevisarResponse } from '@/features/proposta/brasil/types/proposta.type'
import { HttpService } from '@/infra'

export class GetPropostaRevisarService extends HttpService {
  async execute(numero: number) {
    const response = await this.http.get<TGetPropostaRevisarResponse>(`api/v2/Proposta/${numero}/revisar`)
    return response
  }
}
